(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PatternInfoCustom', PatternInfoCustom);

    PatternInfoCustom.$inject = ['$resource'];

    function PatternInfoCustom($resource) {


        var getAllCompanyPatterns = function () {

            var resourceUrl = 'api/get-all-company-patterns';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyPatterns: getAllCompanyPatterns,

        };
    }
})();
